import { type Registry as Services, service } from '@ember/service';
import Model, { belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { TransactionMappingHierarchyCategory } from 'lumen/models';
import type { SubCategory } from 'lumen/utils/constants/transaction-mapping/constants';
import { SUB_CATEGORY_TRANSLATIONS } from 'lumen/utils/constants/transaction-mapping/translation-constants';

export default class TransactionMappingHierarchySubCategory extends Model {
  [Type] = 'transaction-mapping/hierarchy-sub-category' as const;

  @belongsTo('transaction-mapping/hierarchy-category', {
    async: false,
    inverse: 'subCategories',
  })
  declare category: TransactionMappingHierarchyCategory;

  @service declare intl: Services['intl'];

  // @ts-expect-error: 'id' is defined as an accessor in class 'Model', but is overridden here in 'TransactionMappingHierarchySubCategory' as an instance property.
  declare id: SubCategory;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get translatedSubCategory() {
    if (!SUB_CATEGORY_TRANSLATIONS[this.id]) {
      return this.id;
    }

    return this.intl.t(SUB_CATEGORY_TRANSLATIONS[this.id]);
  }
}
